"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Lookup
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryToJSON = exports.CategoryFromJSONTyped = exports.CategoryFromJSON = void 0;
function CategoryFromJSON(json) {
    return CategoryFromJSONTyped(json, false);
}
exports.CategoryFromJSON = CategoryFromJSON;
function CategoryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'description': json['description'],
    };
}
exports.CategoryFromJSONTyped = CategoryFromJSONTyped;
function CategoryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'description': value.description,
    };
}
exports.CategoryToJSON = CategoryToJSON;
//# sourceMappingURL=Category.js.map